module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-marriage-certificate-18b021dd71ee07a2448eafe73e23b03e.png";